"use strict";
import { icons } from '../_config'
export const iconHelper={
  getIcon,
  getMapBusIcon,
  getMapStationIcon
}

function getIcon(id, typeIcon='normal'){
  let iconResult = icons.baseIcon
  let icon = ''
  if(typeIcon == 'normal')
    icon = icons.normal
  else if(typeIcon == 'start')
    icon = icons.start
  else if(typeIcon=='end')
    icon = icons.end
  iconResult.html =`<span class="nodeid">${id}</span><img src="${icon}">`

  return  new L.divIcon(iconResult)
}

function getMapBusIcon(){

  const busIcon = Object.assign({}, icons.baseIcon)

  busIcon.iconUrl = icons.bus
  busIcon.iconSize = [14,14]
  busIcon.iconAnchor= [7, 7]

  return new L.icon(busIcon)
}

function getMapStationIcon(){
  const stationIcon = icons.baseIcon
  stationIcon.iconUrl = icons.station

  return new L.icon(stationIcon)
}






// WEBPACK FOOTER //
// ./src/_helpers/icon.helper.js